module.exports = __webpack_public_path__ + "media/images/Truck 1300 900-780a2545.jpeg";